<div class="method-type-manager">
  <div class="method-type-manager__header">
    <h3 class="method-type-manager__title">{{ 'core.method_types' | translate | uppercase }}</h3>
  </div>

  <button type="button" class="btn btn-primary btn-block" (click)="onNewMethodType()" data-cy="new-method-type">
    <i class="ri-add-circle-line"></i>
    {{ 'button.new_method_type' | translate }}
  </button>

  <div class="method-type-manager__lists">
    <!-- Left: all available method types (paginated catalog with search) -->
    <section class="method-type-manager__list">
      <h4 class="method-type-manager__list-title">{{ 'title.available_method_types' | translate }}</h4>

      <ts-paginated-search-header
        [searchValue]="facade.searchTerm$ | async"
        [previousTokens]="facade.previousMethodTypeTokens$ | async"
        [lastItem]="facade.nextMethodTypeToken$ | async"
        [length]="facade.totalCount$ | async"
        [pageSize]="facade.pageSize$ | async"
        [pageSizeOptions]="pageSizeOptions"
        [disabled]="facade.loading$ | async"
        [counting]="facade.counting$ | async"
        (searchChanged)="searchTermChanged($event)"
        (pageChange)="handlePageEvent($event)"
      ></ts-paginated-search-header>

      <ts-method-types-list
        [items]="facade.availableMethodTypes$ | async"
        [columns]="leftColumns"
        [loading]="facade.loading$ | async"
        [noMethodTypes]="facade.noMethodTypes$ | async"
        (assignedToggled)="onToggleAvailable($event)"
      ></ts-method-types-list>
    </section>

    <!-- Right: method types assigned to this case type (all staged, no pagination) -->
    <section class="method-type-manager__list method-type-manager__list--assigned">
      <h4 class="method-type-manager__list-title">{{ 'title.assigned_method_types' | translate }}</h4>

      <div class="method-type-manager__assigned-scroll">
        <ts-method-types-list
          [items]="facade.assignedMethodTypes$ | async"
          [columns]="rightColumns"
          [noMethodTypes]="facade.assignedNoMethodTypes$ | async"
          emptyMessageKey="info.no_assigned_method_types"
          (assignedToggled)="onUnassign($event)"
          (editClicked)="onEditMethodType($event)"
        ></ts-method-types-list>
      </div>
    </section>
  </div>
</div>
